import type { ComputedRef } from "vue";
import { SEGMENT_TRACK_EVENTS } from "~/constants/segment";

export type TSharingProvider = "facebook" | "x" | "whatsapp";
export interface IUseSharingOptions {
  url: string;
  title?: string;
  text?: string;
  eventId: string;
  clipId?: string;
  isClip?: boolean;
}

const share_provider_url: Record<TSharingProvider, (data: IUseSharingOptions) => string> = {
  facebook: (data: IUseSharingOptions) => `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(data.url)}&title=${data.title}`,
  x: (data: IUseSharingOptions) => `https://twitter.com/intent/tweet/?url=${encodeURIComponent(data.url)}&text=${data.title}`,
  whatsapp: (data: IUseSharingOptions) => `https://wa.me/?text=${encodeURIComponent(data.url)}`,
//   email: (data: IUseSharingOptions) => `mailto:?subject=${data.title}&body=${data.url}${data.text ? `\\n${data.text}` : ""}`,
};

export default function useSharing(options: ComputedRef<IUseSharingOptions>) {
  const segment = useSegment();

  const shareProviderUrl = (provider: TSharingProvider): string => {
    return share_provider_url[provider](options.value);
  };

  const trackShare = (provider: TSharingProvider) => {
    const trackEvent = options.value.isClip ? SEGMENT_TRACK_EVENTS.CLIP_SHARE_TO_SOCIAL : SEGMENT_TRACK_EVENTS.EVENT_SHARE_TO_SOCIAL;

    segment.track(trackEvent, {
      event_id: options.value.eventId,
      clip_id: options.value.clipId,
      method: provider,
    });
  };

  return { shareProviderUrl, trackShare };
}
